import { z } from 'zod';

export const QuoteCalculatorSchema = z.object({
  qcid: z.number().optional(),
  qcjid: z.number().nullable().optional(),
  qccosts: z.number().nullable().optional(),
  qcmarkup: z.number().nullable().optional(),
  qcdata: z.string().nullable().optional(),
  qcevreportids: z.string().nullable().optional(),
});

export const UpdateQuoteCalculatorSchema = QuoteCalculatorSchema.partial().required({ qcid: true });
export const CreateQuoteCalculatorSchema = QuoteCalculatorSchema.omit({ qcid: true });

export type QuoteCalculator = z.infer<typeof QuoteCalculatorSchema>; 
export type UpdateQuoteCalculator = z.infer<typeof UpdateQuoteCalculatorSchema>;
export type CreateQuoteCalculator = z.infer<typeof CreateQuoteCalculatorSchema>;